<template>
  <a-card :bordered="false">
    <div class="salesCard">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6"  :sm="12">
              <a-form-item label="法人">
                <a-input placeholder="" v-model="queryParam.legalPerson"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6"  :sm="12">
              <a-form-item label="事业群">
                <a-select
                  placeholder="请选择事业群"
                  v-model="queryParam.bg"
                  :options="businessGroupOptions"
                  allowClear>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xl="6" :sm="12">
              <a-form-item label="事业处">
                <a-input placeholder="" v-model="queryParam.bu"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-button type="primary" v-has="'preAnalysis:search'"  @click="searchQuery" icon="search">查询</a-button>
                        <a-button type="primary" v-has="'preAnalysis:reset'"  @click="searchResetCurr" icon="reload" style="margin-left: 8px">重置</a-button>
                    </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button type="primary" v-has="'preAnalysis:export'" icon="download" @click="handleExportXls('统计报表')">导出</a-button>
      </div>
      <!-- table区域-begin -->
      <div>
        <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div> -->

        <a-table
          ref="table"
          bordered
          rowKey="id"
          size="middle"
          :scroll="{x:true}"
          :columns="columns1"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
        </a-table>
      </div>
    </div>
  </a-card>
</template>

<script>
import JInput from '@/components/jeecg/JInput'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import {getAction, postAction} from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: "AnalysisReport",
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
  },
  data() {
    return {
      model:{},
      queryParam:{},
      factoryOptions:[],
      areaOptions:[],
      buildOptions:[],
      columns:[],
      inspectDateHour:'',
      appCode:"prevent",
      url: {
        list:"/prevent/epm/listReport",
        exportXlsUrl: "/prevent/epm/exportXls",
        queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList"
      },
      businessGroupOptions:[],
      businessUnitOptions:[],

    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    columns1(){
      if(this.language){
        return  [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '工号',
            align:"center",
            dataIndex: 'employeeNo'
          },
          {
            title:'姓名',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'电话',
            align:"center",
            dataIndex: 'mobile'
          },
          {
            title:'所属法人',
            align:"center",
            dataIndex: 'legalPerson'
          },
          {
            title:'事业群',
            align:"center",
            dataIndex: 'bgName'
          },
          {
            title:'事业处',
            align:"center",
            dataIndex: 'buName'
          },
          {
            title:'核酸最后采样时间',
            align:"center",
            dataIndex: 'collectTime',
            customRender:function (text,r,index) {
              if(text == null || text == "")
              {
                return "无记录";
              }
              else
              {
                return text;
              }
            }
          },
          {
            title:'数据同步时间',
            align:"center",
            dataIndex: 'checkTime',
            customRender:function (text,r,index) {
              if(text == null || text == "")
              {
                return "无记录";
              }
              else
              {
                return text;
              }
            }
          }
        ]
      }
    },
  },
  created() {
    this.initBusinessGroupList();
  },
  methods: {
    /********************************初始化数据*******************************************************/
    initBusinessGroupList(){
      getAction(this.url.queryBusinessGroupList,{applicationCode: this.appCode}).then(res=>{
        if(res.success){
          this.businessGroupOptions = res.result.map((item,index,arr)=>{
            let c = {label:item.departName, value: item.orgCode}
            return c;
          })
        }
      })
    },
    searchResetCurr() {
      this.queryParam = {};
      this.searchQuery();
    }
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less'
</style>